import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class EdiaryResponseSelectionService {
	
  async getById(responseSelectionId: number) {
	return await Api().get(`${API_URL}/ediaryResponseSelection/${responseSelectionId}`, { headers:  authHeader() as any });      
  }
  async find() {
    return await Api().get(`${API_URL}/ediaryResponseSelection/find`, { headers:  authHeader() as any });      
  }

  async updateResponseSelection(responseSelection: any) {
    return await Api().put(`${API_URL}/ediaryResponseSelection/${responseSelection.id}`, responseSelection, 
    { method: 'PUT',
      headers:  authHeader() as any });      
  }

  async createResponseSelection(responseSelection: any) {
    return await Api().post(`${API_URL}/ediaryResponseSelection/`, responseSelection, 
    { method: 'POST',
      headers:  authHeader() as any });      
  }

  async deleteResponseSelection(responseSelection: any) {
    return await Api().delete(`${API_URL}/ediaryResponseSelection/${responseSelection.id}`, 
    { method: 'DELETE',
      headers:  authHeader() as any });      
  }
}

export default new EdiaryResponseSelectionService();